import { render, staticRenderFns } from "./LayoutsFormDialog.vue?vue&type=template&id=afd46418"
import script from "./LayoutsFormDialog.vue?vue&type=script&lang=js"
export * from "./LayoutsFormDialog.vue?vue&type=script&lang=js"
import style0 from "./LayoutsFormDialog.vue?vue&type=style&index=0&id=afd46418&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports